import {ComponentFactoryResolver, Injectable, ViewContainerRef} from '@angular/core';
import {CadastroRegraComponent} from "../../regra/cadastro-regra/cadastro-regra.component";
import {ModalCarteiraComponent} from "./modal-carteira/modal-carteira.component";
import {ModalAssociacaoComponent} from "./modal-associacao/modal-associacao.component";
import {ModalRegraCompostaComponent} from "./modal-regra-composta/modal-regra-composta.component";
import {ModalRegraComponent} from "./modal-regra/modal-regra.component";
import {ModalImportacaoLoteComponent} from "../modal-importacao-lote/modal-importacao-lote.component";
import {ModalGrupoCarteiraComponent} from "./modal-grupo-carteira/modal-grupo-carteira.component";
import {
  ModalAssociacaoGrupoCarteiraComponent
} from "./modal-associacao-grupo-carteira/modal-associacao-grupo-carteira.component";

@Injectable({
  providedIn: 'root'
})
export class ComponentSelectorService {

  constructor(private readonly cfr: ComponentFactoryResolver) {}

  private readonly componentTypes = {
    'Carteira' : ModalCarteiraComponent,
    'Regra simples' : CadastroRegraComponent,
    'Regra composta' : ModalRegraCompostaComponent,
    'Associação' : ModalAssociacaoComponent,
    'Regra': ModalRegraComponent,
    'Importação de Planilha': ModalImportacaoLoteComponent,
    'Grupo de Carteira': ModalGrupoCarteiraComponent,
    'Associação de Grupo de Carteira': ModalAssociacaoGrupoCarteiraComponent,
  }

  public loadComponent(vcr: ViewContainerRef,type: string){
    vcr.clear();
   return vcr.createComponent(
        this.cfr.resolveComponentFactory(this.componentTypes[type]));
  }

}
